<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <div class="page-title">課題範圍</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <AddButton @click.native="onAdd">
            <template v-slot:title>新增課題範圍</template>
          </AddButton>
        </el-col>
      </el-row>

      <div>
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column type="index" width="50" label="#"> </el-table-column>
          <el-table-column
            
            label="課題範圍"
            width="150"
            align="left"
          >
          <template slot-scope="{row}">
             <span>{{row.name.zhTc}} / {{row.name.en}}</span>
          </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="medium" @click="onEditButton(row.id)"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDeleteButton(row.id)"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <dialogSlot
      :centerDialogVisible="dialogSlotVisible"
      @confirmFunction="onDialogConfirmFunction"
      @onCancelButton="onDialogCancelButton"
    >
      <el-form
        :rules="rules"
        label-position="left"
        label-width="180px"
        ref="ruleForm"
        :model="formLabelAlign"
      >
        <el-form-item label="中文課題範圍" :prop="'name.'+'zhTc'" :rules="[ { required: true, message: '', trigger: 'blur' },]">
          <el-input v-model="formLabelAlign.name.zhTc" class="fixed-with-330-input">
          </el-input>
        </el-form-item>
        <el-form-item label="英文課題範圍" :prop="'name.'+'en'"  :rules="[ { required: true, message: '', trigger: 'blur' },]">
          <el-input v-model="formLabelAlign.name.en" class="fixed-with-330-input">
          </el-input>
        </el-form-item>
      </el-form>
    </dialogSlot>
    <deleteDialog
      titleCh="您確定要刪除此課題範圍嗎？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="onConfirmButton"
      @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import AddButton from "@/components/addButton";
import deleteDialog from "@/components/deleteDialog";
import dialogSlot from "@/components/dialogSlot";
import {
  getProgramTypes,
  addProgramTypes,
  getProgramTypesDetail,
  deleteProgramTypes,
  putProgramTypes,
} from "@/api/dictionary";
export default {
  components: { AddButton, deleteDialog, dialogSlot },
  data() {
    return {
      isEdit: false,
      programmeId: null,
      formLabelAlign: {
        name: {
          en: null,
          zhTc: null,
        },
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
    };
  },
  created() {
    this.getProgramTypes();
  },
  methods: {
    onDialogConfirmFunction() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.putProgramTypes();
          } else {
            this.addProgramTypes();
          }
        } else {
          return false;
        }
      });
    },
    onDialogCancelButton() {
      this.dialogSlotVisible = false;
    },
    onConfirmButton() {
      this.deleteProgramTypes();
    },
    onEditButton(id) {
      this.isEdit = true;
      this.programmeId = id;
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
        this.$refs.ruleForm.resetFields();
      });
      this.getProgramTypesDetail();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    onDeleteButton(id) {
      this.programmeId = id;
      this.centerDialogVisible = true;
    },
    onAdd() {
      this.isEdit = false;
      this.dialogSlotVisible = true;
      this.formLabelAlign = {
        name: {
          en: null,
          zhTc: null,
        },
      },
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
        this.$refs.ruleForm.resetFields();
      });
    },
    getProgramTypes() {
      getProgramTypes().then((v) => {
        this.tableData = v.data;
      });
    },
    addProgramTypes() {
      addProgramTypes(this.formLabelAlign)
        .then(() => {
          this.getProgramTypes();
        })
        .finally(() => {
          this.dialogSlotVisible = false;
        });
    },
    getProgramTypesDetail() {
      getProgramTypesDetail(this.programmeId).then((v) => {
        this.formLabelAlign = v.data;
        this.dialogSlotVisible = true;
      });
    },
    deleteProgramTypes() {
      deleteProgramTypes(this.programmeId)
        .then(() => {
          this.getProgramTypes();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    putProgramTypes() {
      putProgramTypes(this.programmeId, this.formLabelAlign)
        .then(() => {
          this.getProgramTypes();
        })
        .finally(() => {
          this.dialogSlotVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .item {
      color: #004eff;
      cursor: pointer;
      font-size: 20px;
    }
  }
}
</style>